import {registerDataRouterApp} from '@github-ui/react-core/register-app'
import {issuesAppBuilder} from './config/app-builder'
import {createIssuesRoutes} from './routes/create-issues-routes'

export const issuesApp = issuesAppBuilder.createDataRouterAppFromRoutes(createIssuesRoutes(issuesAppBuilder))
registerDataRouterApp(issuesApp)
